import React, { forwardRef } from 'react';
import classnames from 'classnames';
import * as styles from './input.module.css';

const InputFieldComponent = (
  {
    id,
    name,
    type = 'text',
    value,
    placeholder,
    label,
    style,
    onChange,
    error,
    required = false,
    readOnly = false,
    hidden = false,
    autoFocus,
    help,
    disabled,
    strong,
    dark,
    customClass,
  },
  ref,
) => {
  return (
    <div
      className={classnames(
        styles.inputField,
        {
          [styles.neddih]: hidden,
          [styles.error]: error,
          [styles.strong]: strong,
          [styles.dark]: dark,
        },
        customClass,
      )}
      style={style}
    >
      <input
        id={id}
        name={name}
        placeholder={placeholder}
        type={type}
        required={required}
        className={styles.textInput}
        onChange={onChange}
        ref={ref}
        readOnly={readOnly}
        autoFocus={autoFocus}
        disabled={disabled}
        tabIndex={hidden ? -1 : undefined}
        {...(value === undefined ? {} : { value })}
      />
      {label && (
        <label htmlFor={id} className={styles.textLabel}>
          {label}
        </label>
      )}
      {error && <span className={styles.errorMessage}>{error}</span>}
      {help && !error && <span className={styles.helpMessage}>{help}</span>}
    </div>
  );
};

export const InputField = forwardRef(InputFieldComponent);
